import React, { useState } from 'react';
import bananatreeleft from '../images/group-banana-tree-left-pic-removebg-preview.png';
import bananatreeright from '../images/group-banana-tree-right-pic-removebg-preview.png';
// import cashewnut from '../images/group-cashews-pic-removebg-preview.png';

const Products = () => {
  const [activeProduct, setActiveProduct] = useState('banana');

  const productData = {
    banana: {
      title: "Premium Organic Bananas",
      description: "Our bananas are grown in sustainable farms, harvested at the perfect ripeness to ensure maximum flavor and nutritional value. Rich in potassium, vitamin B6, and natural sugars for instant energy.",
      features: [
        "100% organic & non-GMO",
        "Harvested at perfect ripeness",
        "Rich in potassium & vitamin B6",
        "Sustainably farmed"
      ],
      price: "$../ kg",
      nutrition: "132 kcal • 34g carbs • 3.1g fiber"
    },
    cashew: {
      title: "Premium Whole Cashews",
      description: "Carefully selected whole cashews, gently roasted to preserve their natural oils and nutrients. These nutrient-dense nuts are packed with healthy fats, protein, and essential minerals like magnesium and zinc.",
      features: [
        "Unsalted & unroasted options",
        "High in magnesium & zinc",
        "No additives or preservatives",
        "Perfect for snacks & cooking"
      ],
      price: "$.. / 500g",
      nutrition: "553 kcal • 30g fat • 18g protein"
    }
  };

  const currentProduct = productData[activeProduct];

  return (
    <div className="products-page">
      {/* Product Selector Tabs */}
      <div className="product-tabs">
        <button
          className={`tab-btn ${activeProduct === 'banana' ? 'active' : ''}`}
          onClick={() => setActiveProduct('banana')}
        >
          Bananas
        </button>
        <button
          className={`tab-btn ${activeProduct === 'cashew' ? 'active' : ''}`}
          onClick={() => setActiveProduct('cashew')}
        >
          Cashews
        </button>
      </div>

      {/* Product Display Area */}
      <div className="product-display">

        {/* Banana Product Section */}
        {activeProduct === 'banana' && (
          <div className="banana-section">
            {/* Left Banana Tree - REPLACE THIS URL WITH YOUR ACTUAL IMAGE */}
            <div className="banana-tree left-tree">
              <img
                src={bananatreeleft}
                alt="Banana Tree"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='600' viewBox='0 0 400 600'%3E%3Crect width='400' height='600' fill='%2316a34a' opacity='0.1'/%3E%3Ctext x='50%25' y='50%25' font-family='Arial' font-size='18' fill='%2316a34a' text-anchor='middle'%3EBanana Tree Image%3C/text%3E%3C/svg%3E";
                }}
              />
            </div>

            {/* Product Content */}
            <div className="product-content">
              <h1 className="product-title">{currentProduct.title}</h1>
              <p className="product-description">{currentProduct.description}</p>

              <div className="product-details-grid">
                <div className="features-section">
                  <h3>Key Features</h3>
                  <ul className="features-list">
                    {currentProduct.features.map((item, idx) => (
                      <li key={idx}>
                        <span className="check-icon">✓</span>
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="purchase-section">
                  <div className="price-info">
                    <div className="price-tag">{currentProduct.price}</div>
                    <div className="nutrition-info">{currentProduct.nutrition}</div>
                  </div>

                  <div className="action-buttons">
                    <button className="btn-add-cart">Add to Cart</button>
                    <button className="btn-buy-now">Buy Now</button>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Banana Tree - REPLACE THIS URL WITH YOUR ACTUAL IMAGE */}
            <div className="banana-tree right-tree">
              <img
                src={bananatreeright}
                alt="Banana Tree"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='600' viewBox='0 0 400 600'%3E%3Crect width='400' height='600' fill='%2316a34a' opacity='0.1'/%3E%3Ctext x='50%25' y='50%25' font-family='Arial' font-size='18' fill='%2316a34a' text-anchor='middle'%3EBanana Tree Image%3C/text%3E%3C/svg%3E";
                }}
              />
            </div>
          </div>
        )}

        {/* Cashew Product Section */}
        {activeProduct === 'cashew' && (
          <>
            <div className="cashew-section">
              {/* Background Cashews - REAL CASHEW IMAGES */}
              {/* Product Content */}
              <div className="product-content cashew-content">
                <h1 className="product-title">{currentProduct.title}</h1>
                <p className="product-description">{currentProduct.description}</p>

                <div className="product-details-grid">
                  <div className="features-section">
                    <h3>Key Features</h3>
                    <ul className="features-list">
                      {currentProduct.features.map((item, idx) => (
                        <li key={idx}>
                          <span className="check-icon">✓</span>
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="purchase-section">
                    <div className="price-info">
                      <div className="price-tag">{currentProduct.price}</div>
                      <div className="nutrition-info">{currentProduct.nutrition}</div>
                    </div>

                    <div className="action-buttons">
                      <button className="btn-add-cart">Add to Cart</button>
                      <button className="btn-buy-now">Buy Now</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>

      {activeProduct === 'cashew' && (
        <>
          <div className="cashew-background">
          </div>
        </>
      )}
      {/* Stats Bar */}
      <div className="product-stats">
        <div className="stat-item">
          <div className="stat-number">100%</div>
          <div className="stat-label">Natural</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">24/7</div>
          <div className="stat-label">Support</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">1000+</div>
          <div className="stat-label">Happy Customers</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">48h</div>
          <div className="stat-label">Delivery</div>
        </div>
      </div>
    </div>
  );
};

export default Products;